import React, { Component } from "react";

import imgblack from "./assets/status/black.png"
import imgorange from "./assets/status/orange.png"
import imgblue from "./assets/status/blue.png"
import imgpurple from "./assets/status/purple.png"
import imggreen from "./assets/status/green.png"
import imggreen_ok from "./assets/status/green_ok.png"
import Button from "../../components/bases/button/button";



class StateInput extends React.Component
{
    
    constructor(props)
    {
        super(props);

        var value = this.props.value;
        if ((value <1) && (!this.props.forsearch)) value=1;
        if (value>5) value=5;
        this.state =
        {
            value: value,
        }

        this.handleStateChange = this.handleStateChange.bind(this);
    }


    handleStateChange(datas)
    {
        if (this.props.readOnly) return;
        this.setState({value: parseInt(datas)})
    }
    componentDidUpdate()
    {
        this.props.onChange();
    }

    setValue(text)
    {
        if (text != this.state.value)
            this.setState({value:text})
    }


    getValue()
    {
        return this.state.value;
    }

    render()
    {


        var t1 = 32;
        var t2 = 22;

        if (this.props.forsearch)
        {
            t1=20;
            t2=15;
        }

        var images =[];

        if (this.props.forsearch)
        {
            images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="0" button={!this.props.readOnly} width={this.state.value==0?t1:t2} height={this.state.value==0?t1:t2} image={imgblack} tooltip={{fr:"Tous",en:"All state"}}/>)
            images.push(<>&nbsp;&nbsp;</>)
    
        }

        images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="1" button={!this.props.readOnly} width={this.state.value==1?t1:t2} height={this.state.value==1?t1:t2} image={imgorange} tooltip={{fr:"A sous-titrer",en:"To be subtitling"}}/>)
        images.push(<>&nbsp;&nbsp;</>)
        images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="2"  button={!this.props.readOnly} width={this.state.value==2?t1:t2} height={this.state.value==2?t1:t2} image={imgblue} tooltip={{fr:"Sous-titrage envoyé",en:"Subtitles sent"}}/>)
        images.push(<>&nbsp;&nbsp;</>)
        images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="3"  button={!this.props.readOnly} width={this.state.value==3?t1:t2} height={this.state.value==3?t1:t2} image={imgpurple} tooltip={{fr:"En cours de relecture",en:"Rereading"}}/>)
        images.push(<>&nbsp;&nbsp;</>)
        images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="4"  button={!this.props.readOnly} width={this.state.value==4?t1:t2} height={this.state.value==4?t1:t2} image={imggreen} tooltip={{fr:"Validé",en:"Validate"}}/>)
        images.push(<>&nbsp;&nbsp;</>)
        images.push(<Button nochangecolor={true} onClick={this.handleStateChange} datas="5"  button={!this.props.readOnly} width={this.state.value==5?t1:t2} height={this.state.value==5?t1:t2} image={imggreen_ok} tooltip={{fr:"Ok",en:"Ok"}}/>)

        return (<>
            <div className = "dialog-Input-Title">
                {this.props.title}
                &nbsp; 
                {images}
            </div>
            
            
        </>);
        }
    

}
StateInput.defaultProps = 
{
    readOnly: false,
    disabled: false,
    value: 1,
    forsearch: false,
}

export default StateInput